import { getFirestoreExceptionMessage } from "./messages/firestore-exceptions";
import { setErrorToast } from "../notifications/toast";
import { getStorageExceptionMessage } from "./messages/firestorage-exceptions";
import { getAuthExceptionMessage } from "./messages/auth-exceptions";
import * as Sentry from "@sentry/vue";
import { FirestoreError } from "firebase/firestore";
import type { StorageError } from "firebase/storage";
import type { AuthError } from "firebase/auth";
import { translate } from "@/i18n/vueI18n";

export function handleFirestoreException({ e }: { e: FirestoreError }): string {
  console.error(e);
  if (
    e.code === "unavailable" &&
    e.message.includes("IndexedDB") &&
    e.message.includes("Refresh the page to try again")
  ) {
    const message = translate("global.toast.database_connection_lost");
    setErrorToast({
      message,
    });
    Sentry.captureException(e);
    window.location.reload();
    return message;
  }

  const message = getFirestoreExceptionMessage(e);
  Sentry.captureException(e);
  return message;
}

export function handleFirestorageException({ e }: { e: StorageError }): string {
  console.error(e);
  const message = getStorageExceptionMessage(e);
  Sentry.captureException(e);
  return message;
}

export function handleAuthException({ e }: { e: AuthError }): string {
  console.error(e);
  const message = getAuthExceptionMessage(e);
  Sentry.captureException(e);
  return message;
}
